import { motion } from "framer-motion";

const PageTransition = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, x: 0 }} // Start: Unsichtbar
      animate={{ opacity: 1, x: 0 }} // Animation beim Erscheinen: Voll sichtbar und an der richtigen Position
      exit={{ opacity: 0, x: 0 }} // Animation beim Verschwinden: Unsichtbar
      transition={{ duration: 0.7 }} // Dauer der Animation
      className={className}
    >
      {children}
    </motion.div>
  );
};

export default PageTransition;
